import { NAMESPACE, NAME } from './constants';
import { reducer } from './reducer';
import { combineReducers } from 'redux';

export const getOrderReturnsReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});
